import type { Theme } from '@mui/material'

const styleOverrides = {
  label: ({ theme }: { theme: Theme }) => ({
    color: theme.palette.text.secondary,
    fontWeight: 'normal',
    fontSize: '1rem',
    lineHeight: 1.5,
    letterSpacing: '0.01em',
  }),
}

const MuiPickersCalendarHeader = {
  styleOverrides,
}

export default MuiPickersCalendarHeader
